var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "gwnl-position-eval__info pb40" },
    [
      _c(
        "yxt-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "form",
          attrs: {
            rules: _vm.rules,
            model: _vm.form,
            "label-width": "100px",
            "is-need-require": "",
            "label-position": "top",
          },
        },
        [
          _c("yxt-blockhead", {
            staticClass: "mt50",
            attrs: {
              title: _vm.$t("pc_base_info"),
              size: "small",
              type: "special",
            },
          }),
          _c(
            "div",
            { staticClass: "ml16 mt8" },
            [
              _c(
                "yxt-form-item",
                {
                  attrs: {
                    label: _vm.$t("pc_gwnl_global_lbl_projectName"),
                    prop: "name",
                  },
                },
                [
                  _c("yxt-input", {
                    attrs: {
                      maxlength: "50",
                      placeholder: _vm.$t("pc_gwnl_global_enterProjectName"),
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "yxt-form-item",
                {
                  attrs: {
                    label: _vm.$t("pc_gwnl_web_lbl_survey_information_hint"),
                    prop: "description",
                  },
                },
                [
                  _c("yxt-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      maxlength: "200",
                      placeholder:
                        _vm.$t("pc_gwnl_web_pleaseEnter") +
                        _vm.$t("pc_gwnl_web_lbl_survey_information_hint"),
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.form.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "description", $$v)
                      },
                      expression: "form.description",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("yxt-blockhead", {
            attrs: {
              title: _vm.$t("pc_talent_lbl_eval_content").d("评估内容"),
              size: "small",
              type: "special",
            },
          }),
          _c("yxt-form-item", { staticClass: "ml16" }, [
            _c("span", { staticClass: "color-red" }, [
              _vm._v(
                _vm._s(
                  _vm
                    .$t("pc_talent_msg_eval_not_pass")
                    .d("对未达到标准的能力项进行评估")
                )
              ),
            ]),
          ]),
          _c("yxt-blockhead", {
            staticClass: "mt32",
            attrs: {
              title: _vm.$t("pc_gwnl_eval_evalSettings"),
              size: "small",
              type: "special",
            },
          }),
          _c(
            "div",
            { staticClass: "ml16 mt8" },
            [
              _c(
                "yxt-form-item",
                {
                  attrs: {
                    size: "small",
                    label: _vm
                      .$t("pc_talent_lbl_sync_relationship")
                      .d("评估关系同步"),
                  },
                },
                [
                  _c("yxt-switch", {
                    attrs: {
                      disabled: !!_vm.id,
                      "active-value": 1,
                      "inactive-value": 0,
                    },
                    on: { change: _vm.onAutoSyncChanged },
                    model: {
                      value: _vm.form.autoSync,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "autoSync", $$v)
                      },
                      expression: "form.autoSync",
                    },
                  }),
                  _c("span", { staticClass: "ml4" }, [
                    _vm._v(
                      _vm._s(
                        _vm
                          .$t("pc_talent_lbl_eval_sync_relationship")
                          .d("自动同步上一次评估任务的评估关系内容")
                      )
                    ),
                  ]),
                  _c(
                    "yxt-tooltip",
                    {
                      attrs: {
                        effect: "dark",
                        placement: "top",
                        content: _vm
                          .$t("pc_talent_tips_sync_relationship")
                          .d(
                            "设置成功后，点击下一步再返回此选项无法进行二次编辑"
                          ),
                      },
                    },
                    [
                      _c("yxt-svg", {
                        staticClass: "ml4 color-gray-6 hand v-mid",
                        attrs: {
                          width: "16px",
                          height: "16px",
                          "icon-class": "question-cirlce-o",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "yxt-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.form.autoSync,
                      expression: "!form.autoSync",
                    },
                  ],
                  attrs: {
                    label: _vm.$t("pc_gwnl_eval_evalRelationship"),
                    required: "",
                    prop: "evaluationConfig4Create",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "flex-col flex",
                      class: { "eval-custom-checkbox": !_vm.expend },
                    },
                    _vm._l(_vm.dimensionInfo, function (item) {
                      return _c(
                        "div",
                        { key: item.type },
                        [
                          item.type !== "2"
                            ? _c(
                                "yxt-checkbox",
                                {
                                  attrs: {
                                    "true-label": 1,
                                    "false-label": 0,
                                    disabled: _vm.disabledRelationBox(item),
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.changeEnable(
                                        _vm.form.evaluationConfig4Create[
                                          item.prop
                                        ],
                                        item.type
                                      )
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.form.evaluationConfig4Create[
                                        item.prop
                                      ],
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form.evaluationConfig4Create,
                                        item.prop,
                                        $$v
                                      )
                                    },
                                    expression:
                                      "form.evaluationConfig4Create[item.prop]",
                                  },
                                },
                                [
                                  _c("eval-tooltip", {
                                    attrs: {
                                      label: item.label,
                                      disabledFunc:
                                        _vm.disabledRelationBox(item),
                                    },
                                  }),
                                ],
                                1
                              )
                            : [
                                _c(
                                  "yxt-checkbox",
                                  {
                                    attrs: {
                                      "true-label": 1,
                                      "false-label": 0,
                                      label: _vm.$t(
                                        "pc_gwnl_global_leaderAssessment"
                                      ),
                                      disabled: _vm.disabledRelationBox(item),
                                    },
                                    on: { change: _vm.changeLeaderEnable },
                                    model: {
                                      value:
                                        _vm.form.evaluationConfig4Create
                                          .enabledLeader,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form.evaluationConfig4Create,
                                          "enabledLeader",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "form.evaluationConfig4Create.enabledLeader",
                                    },
                                  },
                                  [
                                    _c("eval-tooltip", {
                                      attrs: {
                                        label: _vm.$t(
                                          "pc_gwnl_global_leaderAssessment"
                                        ),
                                        disabledFunc:
                                          _vm.disabledRelationBox(item),
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm.form.evaluationConfig4Create
                                  .enabledLeader === 1
                                  ? [
                                      _c(
                                        "yxt-radio",
                                        {
                                          attrs: { label: "enabledLeaderPm" },
                                          on: { change: _vm.changeLeaderType },
                                          model: {
                                            value: _vm.leaderType,
                                            callback: function ($$v) {
                                              _vm.leaderType = $$v
                                            },
                                            expression: "leaderType",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$t(
                                                  "pc_gwnl_eval_departmentManager"
                                                )
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "yxt-radio",
                                        {
                                          attrs: { label: "enabledLeaderDm" },
                                          on: { change: _vm.changeLeaderType },
                                          model: {
                                            value: _vm.leaderType,
                                            callback: function ($$v) {
                                              _vm.leaderType = $$v
                                            },
                                            expression: "leaderType",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$t(
                                                  "pc_gwnl_eval_directManager"
                                                )
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                        ],
                        2
                      )
                    }),
                    0
                  ),
                  _vm.dimensionInfo && _vm.dimensionInfo.length > 6
                    ? _c(
                        "div",
                        {
                          staticClass: "eval-custom-text hand",
                          on: {
                            click: function ($event) {
                              _vm.expend = !_vm.expend
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "color-primary-6" }, [
                            _vm._v(
                              _vm._s(
                                _vm.expend
                                  ? _vm.$t("pc_gwnl_clamp_retract" /* 收起 */)
                                  : _vm.$t("pc_comp_sideBar_open" /* 展开 */)
                              )
                            ),
                          ]),
                          _c("yxt-svg", {
                            staticClass: "color-primary-6 ml4",
                            attrs: {
                              width: "14px",
                              height: "14px",
                              "icon-class": _vm.expend
                                ? "arrow-up"
                                : "arrow-down",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
              _vm.form.autoSync || (_vm.weightList && _vm.weightList.length > 1)
                ? _c(
                    "div",
                    [
                      _c(
                        "yxt-form-item",
                        {
                          attrs: {
                            label: _vm.$t("pc_gwnl_eval_lbl_evalWeight"),
                            prop: "weight",
                            "label-tooltip": _vm.$t(
                              "pc_gwnl_eval_weightSettingTooltip"
                            ),
                            size: "small",
                            required: "",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "flex flex-col" },
                            [
                              _c(
                                "yxt-radio",
                                {
                                  attrs: { label: 1 },
                                  on: { change: _vm.setAverageWeight },
                                  model: {
                                    value:
                                      _vm.form.evaluationConfig4Create
                                        .weightType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form.evaluationConfig4Create,
                                        "weightType",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "form.evaluationConfig4Create.weightType",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t("pc_gwnl_eval_averageWeight")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                [
                                  _c(
                                    "yxt-radio",
                                    {
                                      attrs: { label: 2 },
                                      on: { change: _vm.setAverageWeight },
                                      model: {
                                        value:
                                          _vm.form.evaluationConfig4Create
                                            .weightType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form.evaluationConfig4Create,
                                            "weightType",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.evaluationConfig4Create.weightType",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t("pc_gwnl_eval_customWeight")
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                  parseInt(
                                    _vm.form.evaluationConfig4Create.weightType
                                  ) === 2
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex flex-wrap mt12 bg-lightgrey pl16 pt16 pb8 yxtbizf-br-4",
                                        },
                                        _vm._l(_vm.weightList, function (item) {
                                          return _c(
                                            "div",
                                            {
                                              key: item.weight,
                                              staticClass:
                                                "flex weight-item mb8",
                                            },
                                            [
                                              _c(
                                                "yxt-tooltip",
                                                {
                                                  attrs: {
                                                    content: item.label,
                                                    placement: "top",
                                                    "open-filter": "",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "mr8 ellipsis",
                                                    },
                                                    [_vm._v(_vm._s(item.label))]
                                                  ),
                                                ]
                                              ),
                                              _c("yxt-input-number", {
                                                staticClass:
                                                  "yxtbiz-flex-shrink-0",
                                                attrs: {
                                                  precision: 0,
                                                  min: 0,
                                                  max: 100,
                                                  formatter:
                                                    _vm.handleFormatter,
                                                },
                                                model: {
                                                  value:
                                                    _vm.weight[item.weight],
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.weight,
                                                      item.weight,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "weight[item.weight]",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        }),
                                        0
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "yxt-form-item",
                        {
                          attrs: {
                            label: _vm
                              .$t("pc_talent_lbl_other_eval_rule")
                              .d("他评分计算规则"),
                            prop: "evaluationConfig4Create.othersWeightType",
                            required: "",
                          },
                        },
                        [
                          _c(
                            "yxt-radio-group",
                            {
                              model: {
                                value:
                                  _vm.form.evaluationConfig4Create
                                    .othersWeightType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form.evaluationConfig4Create,
                                    "othersWeightType",
                                    $$v
                                  )
                                },
                                expression:
                                  "form.evaluationConfig4Create.othersWeightType",
                              },
                            },
                            [
                              _c(
                                "div",
                                [
                                  _c(
                                    "yxt-radio",
                                    { attrs: { label: 0 } },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm
                                              .$t("pc_talent_msg_use_weight")
                                              .d("权重计算")
                                          ) +
                                          "\n                "
                                      ),
                                      _c(
                                        "yxt-tooltip",
                                        {
                                          staticClass: "item v-middle",
                                          attrs: {
                                            content: _vm
                                              .$t(
                                                "pc_talent_tips_eval_use_weight"
                                              )
                                              .d(
                                                "除自评外，将他评各个关系按照自身权重进行加权平均计算，举例：他评分=（上级评分*上级权重+平级评分*平级权重+下级评分*下级权重）/（上级权重+平级权重+下级权重）"
                                              ),
                                            placement: "top",
                                            "max-width": 400,
                                          },
                                        },
                                        [
                                          _c("yxt-svg", {
                                            staticClass:
                                              "color-gray-6 pb2 hover-primary-6 hand v-mid ml5",
                                            attrs: {
                                              width: "16px",
                                              height: "16px",
                                              "icon-class": "question-cirlce-o",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "mt8" }, [
                                _c(
                                  "div",
                                  { staticClass: "eval-self-weight-left" },
                                  [
                                    _c(
                                      "yxt-radio",
                                      { attrs: { label: 1 } },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm
                                                .$t(
                                                  "pc_talent_msg_eval_not_use_weight"
                                                )
                                                .d("非权重计算")
                                            ) +
                                            "\n                  "
                                        ),
                                        _c(
                                          "yxt-tooltip",
                                          {
                                            attrs: {
                                              content: _vm
                                                .$t(
                                                  "pc_talent_tips_eval_not_use_weight"
                                                )
                                                .d(
                                                  "除自评外所有人员的评估分平均计算，举例：他评分= （非自评人员评分和）/（非自评人员总数）"
                                                ),
                                              placement: "top",
                                              "max-width": 400,
                                            },
                                          },
                                          [
                                            _c("yxt-svg", {
                                              staticClass:
                                                "color-gray-6 hover-primary-6 pb2 hand v-mid ml5",
                                              attrs: {
                                                width: "16px",
                                                height: "16px",
                                                "icon-class":
                                                  "question-cirlce-o",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("yxtbiz-eval-step-footer", {
        attrs: { operation: _vm.operation, "footer-width": "960px" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }